import axios from 'axios'
import Keycloak from 'keycloak-js'

export const initAxios = (
  baseURL: string,
  keycloak: Keycloak,
  publicUrls: string[] = []
): void => {
  axios.defaults.baseURL = baseURL

  axios.interceptors.request.use(async config => {
    const isPublicUrl = publicUrls.some(publicUrl =>
      config.url?.startsWith(publicUrl)
    )

    if (isPublicUrl || !keycloak.authenticated) {
      return config
    }

    try {
      await keycloak.updateToken(5)
      config.headers.Authorization = `Bearer ${keycloak.token}`
      return config
    } catch (error) {
      console.error(
        'Failed to refresh token or user is not authenticated',
        error
      )
      return Promise.reject(error)
    }
  })
}
